/* ========================================================================
* DOM-based Routing
* Based on http://goo.gl/EUTi53 by Paul Irish
*
* Only fires on body classes that match. If a body class contains a dash,
* replace the dash with an underscore when adding it to the object below.
*
* .noConflict()
* The routing is enclosed within an anonymous function so that you can
* always reference jQuery with $, even when in .noConflict() mode.
* ======================================================================== */

/*global jQuery ES_CONFIG*/

(function($) {
	var App = {
		common: function() {
			//Init all objects that will be fired on all pages here.
			$(document).foundation();
			this.slick.init();
			this.searchBar.init();
			this.offCanvas.init();
			this.ajaxSearch.init();
			this.smoothScroll.scroll();
		},
		slick: {
			init: function() {
				this.fader();
				this.slider();
				this.carousel();
			},
			faderSelector: '.es-slick-fader',
			sliderSelector: '.es-slick-slider',
			carouselSelector: '.es-slick-carousel',
			sliderSettings: {
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				fade: false,
				autoplay: true,
				autoplaySpeed: 4000,
				pauseOnHover: true,
				arrows: true,
				dots: false,
				infinite: true,
			},
			carouselSettings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				fade: false,
				autoplay: true,
				autoplaySpeed: 4000,
				pauseOnHover: true,
				arrows: false,
				dots: false,
				infinite: true,
				centerMode: false,
				responsive: [
					{
					  breakpoint: 1200,
					  settings: {
						centerMode: true,
						slidesToShow: 1,
						slidesToScroll: 1
					  }
					},
					{
					  breakpoint: 760,
					  settings: {
						centerMode: false,
						slidesToShow: 1,
						slidesToScroll: 1
					  }
					}
				]
			},
			faderSettings: {
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				fade: true,
				autoplay: false,
				autoplaySpeed: 4000,
				pauseOnHover: true,
				arrows: true,
				dots: false,
				infinite: true,
			},
			slider: function() {
				$(this.sliderSelector).slick(this.sliderSettings);
			},
			fader: function() {
				$(this.faderSelector).slick(this.faderSettings);
			},
			carousel: function() {
				$(this.carouselSelector).slick(this.carouselSettings);
			}
		},

		searchBar: {
			init: function() {
				var win = $(window),
					search = $('.searchform');

				win.on("click.Bst", function(event){
					if ( search.has(event.target).length == 0 && !search.is(event.target) ){
						$('.searchform').removeClass('open-search');
						$('.header__top').show();
					} else {
						if($('.searchform').hasClass('open-search')) {
							return true;
							$('.searchform').removeClass('open-search');
							$('.header__top').show();
						} else {
							event.preventDefault();
							$('.searchform').addClass('open-search');
							$('.search-form input').keypress(function() {
								$('.menu-row').css('overflow', 'visible');
							});
							$('.header__top').hide();
						}
					}
				});
				// $('.searchform .search-form__submit').mouseup(function() {

				// 	if($('.searchform').hasClass('open-search')) {
				// 		return true;
				// 		$('.searchform').removeClass('open-search');
				// 		$('.header__top').show();
				// 	} else {
				// 		event.preventDefault();
				// 		$('.searchform').addClass('open-search');
				// 		$('.search-form input').keypress(function() {
				// 			$('.menu-row').css('overflow', 'visible');
				// 		});
				// 		$('.header__top').hide();
				// 	}
				// });
			},
		},

		ajaxSearch: {
			init: function() {

				$('.research-search input[type="search"]').each( function () {
					$(this).on('keyup', function () {
						App.ajaxSearch.researchAjax();
					});
				});

				$('.research-search .search-form__submit').click( function (event) {
					event.preventDefault();
					App.ajaxSearch.researchAjax();
				});

				$('.resource-search input[type="search"]').each( function () {
					$(this).on('keyup', function () {
						App.ajaxSearch.resourceAjax();
					});
				});

				$('.people-search input[type="search"]').each( function () {
					$(this).on('keyup', function () {
						App.ajaxSearch.peopleAjax();
					});
				});

				$('.resource-search .search-form__submit').click( function (event) {
					event.preventDefault();
					App.ajaxSearch.resourceAjax();
				});

				$('.resource-search .search-form__select').change( function (event) {
					event.preventDefault();
					App.ajaxSearch.resourceAjax();
				});

				$('.research-search .search-form__select').change( function (event) {
					event.preventDefault();
					App.ajaxSearch.researchAjax();
				});

				$('.people-search .search-form__submit').click( function (event) {
					event.preventDefault();
					App.ajaxSearch.peopleAjax();
				});

				$('.people-search .people-postform').change( function (event) {
					event.preventDefault();
					window.location.href = $(this).find('option:selected').attr('value');
				});

				$('.post-search input[type="search"]').each( function () {
					$(this).on('keyup', function () {
						App.ajaxSearch.postAjax();
					});
				});

				$('.post-search .search-form__submit').click( function (event) {
					event.preventDefault();
					App.ajaxSearch.postAjax();
				});
			},

			researchAjax: function() {
				var keyword = $('.search-form__field--keyword').val(),
					author = $('.search-form__field--author').val(),
					current_post_term = $('.archive-term').attr('post-term'),
					research_theme = $('.research-theme-postform').find('option:selected').attr('value'),
					research_institution = $('.research-institution').find('option:selected').attr('value'),
					research_region = $('.research-region').find('option:selected').attr('value'),
					order = $('.research-sort').find('option:selected').attr('value'),
					term_title = $('.cat-intro h1').html(),
					ajax_args = {
						url: ES_CONFIG.admin_url,
						type: 'POST',
						nonce: ES_CONFIG.nonce,
						data: {
							action: 'research_posts',
							keyword: keyword,
							author: author,
							post_term: current_post_term,
							title: term_title,
							theme: research_theme,
							institution: research_institution,
							region: research_region,
							order: order,
						}
					},
					reset_args = {
						url: ES_CONFIG.admin_url,
						type: 'POST',
						nonce: ES_CONFIG.nonce,
						data: {
							action: 'research_posts',
							keyword: '',
							author: '',
							post_term: current_post_term,
							title: term_title,
							theme: '',
							institution: '',
							region: '',
							order: 'date',
						}
					};

				$.ajax(ajax_args).done( function(ret){
					$('.archive-posts-grid').html(ret);
					if(keyword.length > 2 ) {
						$('.archive__post--text').mark(keyword);
					}

					$('.reset-button').on('click', function () {
						event.preventDefault();
						$('.research-search')[0].reset();
						$.ajax(reset_args).done( function(ret){
							$('.archive-posts-grid').html(ret);
						});
					});
				});

				var baseUrl = [location.protocol, '//', location.host, location.pathname].join('');

				var filter_params = { 'research-theme': research_theme, 'research-institution': research_institution, 'research-region': research_region, 'order': order};

				history.replaceState(null, null, baseUrl + '?' + $.param(filter_params));

			},

			resourceAjax: function() {
				var keyword = $('.search-form__field--keyword').val(),
					author = $('.search-form__field--author').val(),
					resource_cat = $('.resource-cat-postform').find('option:selected').attr('value'),
					resource_theme = $('.resource-theme-postform').find('option:selected').attr('value'),
					resource_region = $('.resource-region-postform').find('option:selected').attr('value'),
					resource_institution = $('.resource-institution-postform').find('option:selected').attr('value'),
					current_post_term = $('.archive-term').attr('post-term'),
					term_title = $('.cat-intro h1').html(),
					ajax_args = {
						url: ES_CONFIG.admin_url,
						type: 'POST',
						nonce: ES_CONFIG.nonce,
						data: {
							action: 'resource_posts',
							keyword: keyword,
							author: author,
							post_term: current_post_term,
							title: term_title,
							resource_cat: resource_cat,
							resource_theme: resource_theme,
							resource_region: resource_region,
							resource_institution: resource_institution,
						}
					},
					reset_args = {
						url: ES_CONFIG.admin_url,
						type: 'POST',
						nonce: ES_CONFIG.nonce,
						data: {
							action: 'resource_posts',
							keyword: '',
							author: '',
							post_term: current_post_term,
							title: term_title,
							resource_cat: '',
							resource_theme: '',
							resource_region: '',
							resource_institution: '',
						}
					};

				$.ajax(ajax_args).done( function(ret){
					$('.archive-posts-grid').html(ret);
					if(keyword.length > 2 ) {
						$('.archive__post--text').mark(keyword);
					}

					$('.reset-button').on('click', function () {
						event.preventDefault();
						$('.resource-search')[0].reset();
						$.ajax(reset_args).done( function(ret){
							$('.archive-posts-grid').html(ret);
						});
					});
				});

				var baseUrl = [location.protocol, '//', location.host, location.pathname].join('');

				var filter_params = { 'resource-cat': resource_cat, 'resource-theme': resource_theme, 'resource-region': resource_region, 'resource-institution': resource_institution };

				history.replaceState(null, null, baseUrl + '?' + $.param(filter_params));
			},

			peopleAjax: function() {
				var keyword = $('.search-form__field--name').val(),
					current_post_term = $('.archive-term').attr('post-term'),
					term_title = $('.term-intro h1').html(),
					ajax_args = {
						url: ES_CONFIG.admin_url,
						type: 'POST',
						nonce: ES_CONFIG.nonce,
						data: {
							action: 'people_posts',
							keyword: keyword,
							post_term: current_post_term,
							title: term_title,
						}
					},
					reset_args = {
						url: ES_CONFIG.admin_url,
						type: 'POST',
						nonce: ES_CONFIG.nonce,
						data: {
							action: 'people_posts',
							keyword: '',
							post_term: current_post_term,
							title: term_title,
						}
					};

				$.ajax(ajax_args).done( function(ret){
					$('.archive-posts-grid').html(ret);
					if(keyword.length > 2 ) {
						$('.archive__post--text').mark(keyword);
					}

					$('.reset-button').on('click', function () {
						event.preventDefault();
						$('.people-search')[0].reset();
						$.ajax(reset_args).done( function(ret){
							$('.archive-posts-grid').html(ret);
						});
					});
				});
			},

			postAjax: function() {
				var keyword = $('.search-form__field--keyword').val(),
					ajax_args = {
						url: ES_CONFIG.admin_url,
						type: 'POST',
						nonce: ES_CONFIG.nonce,
						data: {
							action: 'post_search',
							keyword: keyword,
						}
					},
					reset_args = {
						url: ES_CONFIG.admin_url,
						type: 'POST',
						nonce: ES_CONFIG.nonce,
						data: {
							action: 'post_search',
							keyword: '',
						}
					};

				$.ajax(ajax_args).done( function(ret){
					$('.archive-posts-grid').html(ret);
					if(keyword.length > 2 ) {
						$('.archive__post--text').mark(keyword);
					}

					$('.reset-button').on('click', function () {
						event.preventDefault();
						$('.post-search')[0].reset();
						$.ajax(reset_args).done( function(ret){
							$('.archive-posts-grid').html(ret);
						});
					});
				});
			}
		},

		offCanvas: {
			init: function() {
				this.button();
			},

			button: function() {
				$('.offcanvas-button').click(function() {
					// $('#offCanvasRight').foundation('toggle');
					$('.toggle-text').addClass('toggle-blur');
					setTimeout(function () {
						$('.toggle-text').removeClass('toggle-blur');
					}, 200);
					if( $('.offcanvas-button').hasClass('menu-open') ) {
						$('.offcanvas-button').removeClass('menu-open');
						document.getElementById('offcanvas-toggle-text').innerHTML = 'Menu';
					} else {
						$('.offcanvas-button').addClass('menu-open');
						document.getElementById('offcanvas-toggle-text').innerHTML = 'Close';
					}
				});

				$('.js-off-canvas-overlay').click(function() {
					$('.offcanvas-button').removeClass('menu-open');
					document.getElementById('offcanvas-toggle-text').innerHTML = 'Menu';
				});
			}
		},

		smoothScroll: {
			scroll: function() {
				$('a[href*="#"]')
				 // Remove links that don't actually link to anything
				 .not('[href="#"]')
				 .not('[href="#0"]')
				 .click(function(event) {
				   // On-page links
				   if (
					 location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
					 &&
					 location.hostname == this.hostname
				   ) {
					 // Figure out element to scroll to
					 var target = $(this.hash);
					 target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
					 // Does a scroll target exist?
					 if (target.length) {
					   // Only prevent default if animation is actually gonna happen
					   event.preventDefault();
					   $('html, body').animate({
						 scrollTop: target.offset().top
					   }, 1000, function() {
						 // Callback after animation
						 // Must change focus!
						 var $target = $(target);
						 $target.focus();
						 if ($target.is(":focus")) { // Checking if the target was focused
						   return false;
						 } else {
						   $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
						   $target.focus(); // Set focus again
						 };
					   });
					 }
				   }
				});
			}
		}
	};

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Router = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages
				App.common();
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function() {
				// JavaScript to be fired on the home page
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function() {
				// JavaScript to be fired on the about us page
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Router;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
